<template>
  <form-wrapper :validator="$v">
    <div
      v-for="(item, index) in items"
      :key="index">
      <children-item
        v-if="!item.deleted"
        :index="parseInt(index)"
        :items="items"
        @del="del(item)"
      />
    </div>

    <b-row v-if="sumCheckedKS">
      <b-col>
        <hr>
        <b-form-group
          :input-cols="3"
          :validator="$v.ks_deti"
          class="required"
          style="margin-right: 10%"
          :label="$t('message.lblUhrnSuma')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              v-bind="attrs"
              v-model="ks_deti"
              v-on="listeners"/>
            <b-form-text>
              {{ $t('message.ksDetiHint') }}
            </b-form-text>
          </template>
        </b-form-group>

      </b-col>
    </b-row>
    <buttons
      :add-row="addNewDietaForm"
      :save="save" />
  </form-wrapper>
</template>

<script>
import { required, requiredIf, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import bFormGroup from '@/components/form-group-col4';
import { containsNumber, yearInterval, monthInterval, dayInterval, rcFormat } from '@/validators';
import restEditor from '@/mixins/restEditor';
import buttons from '@/components/buttons.vue';
import childrenItem from './items/children.vue';

function vyzDetiData(parent) {
  return {
    id: null,
    parent,
    deleted: false,
    priezvisko_meno: '',
    rc: '',
    ks: 0,
    bonus: 0,
    fullYear: 1,
    months: [],
  };
}

export default {
  components: {
    childrenItem,
    bFormGroup,
    buttons,
  },

  mixins: [restEditor],

  data() {
    const id = this.$route.params.userId;
    return {
      id,
      ks_deti: null,
      items: [vyzDetiData(id)],
    };
  },

  validations() {
    const validations = {
      items: {
        $each: {
          deleted: {},
          priezvisko_meno: {
            required: requiredIf(vm => !vm.deleted),
            containsNumber,
            maxLength: maxLength(60),
          },
          rc: {
            required: requiredIf(vm => !vm.deleted),
            maxLength: maxLength(11),
            checkYear: (value, vm) => {
              return vm.deleted ? true : yearInterval(vm.rc)
            },
            checkMonth: (value, vm) => {
              return vm.deleted ? true : monthInterval(vm.rc)
            },
            checkDay: (value, vm) => {
              return vm.deleted ? true : dayInterval(vm.rc)
            },
            checkRcFormat: (value, vm) => {
              return vm.deleted ? true : rcFormat(vm.rc)
            }
          },
          ks: {},
          bonus: {},
          fullYear: {},
          months: {
            required: requiredIf(vm => vm.fullYear != '1' && (vm.deleted === false) && vm.bonus != '1'),
          },
        },
      },
      ks_deti: {
        required: requiredIf(() => this.sumCheckedKS > 0),
      },
    };

    if (this.sumCheckedKS) {
      validations.ks_deti.minValue = minValue(1);
      validations.ks_deti.maxValue = maxValue(50 * this.sumCheckedKS);
    }
    return validations;
  },

  computed: {
    sumCheckedKS() {
      const ret = this.items.filter(item => parseInt(item.ks, 10) === 1).length;

      if (ret === 0) {
        this.ks_deti = null
      }

      return ret
    }
  },

  methods: {
    async processGet() {
      await this.getChildren();
      if (this.sumCheckedKS) {
        await this.getKsAmount();
      }
    },

    async processSave() {
      await this.saveChildren();
    },

    async getChildren() {
      const data = await this.restDataSource.getItems(this.id, 'children');
      if (data.items.length) {
        this.items = [];
      }

      data.items.forEach((item) => {
        const newItem = vyzDetiData(null);

        newItem.id = item.id;
        newItem.parent = item.parent;
        newItem.priezvisko_meno = item.priezvisko_meno;
        newItem.rc = item.rc;
        newItem.fullYear = item.mesiace === 'full' ? 1 : 0;
        newItem.ks = item.ks;
        newItem.bonus = item.bonus;

        if (item.mesiace !== 'full') {
          newItem.months = item.mesiace.split(',');
        }

        this.items.push(newItem);
      });
    },

    async getKsAmount() {
      const restData = await this.restDataSource.getData(this.id, 'etc');
      this.ks_deti = restData.ks_deti;
    },

    async saveChildren() {
      await this.items.forEach(async (item, key) => {
        if (item.deleted) {
          // delete existing item
          if (item.id) {
            await this.restDataSource.deleteData(item, 'children');
          }
          // do not save deleted item
          return;
        }

        if (item.id > 0) {
          await this.restDataSource.updateData(item, 'children');
        } else {
          item.id = (await this.restDataSource.createData(item, 'children')).id;
        }
      });

      await this.$nextTick(async () => {
        this.items = this.items.filter(item => !item.deleted);
        await this.saveKsAmount();
      })
    },

    async saveKsAmount() {
      const ks_deti = this.sumCheckedKS ? this.ks_deti : null;
      await this.$nextTick(async () => {
         await this.restDataSource.updateData({ id: this.id, ks_deti }, 'etc');
      })
      this.$v.$reset();
    },

    addNewDietaForm() {
      this.items.push(vyzDetiData(this.id));
    },
  },
};
</script>
